import { atom, useAtom } from 'jotai';

interface AtomProps {
  requiredPlan: string;
  limit: number;
}

const isLimitReachedOpenAtom = atom<undefined | AtomProps>(undefined);

export function useLimitReached() {
  const [isLimitReachedModalOpen, setIsLimitReachedModalOpen] = useAtom(
    isLimitReachedOpenAtom,
  );

  return {
    isOpen: !!isLimitReachedModalOpen,
    requiredPlan: isLimitReachedModalOpen?.requiredPlan,
    close: () => setIsLimitReachedModalOpen(undefined),
    openLimitModal: (v: AtomProps) => setIsLimitReachedModalOpen(v),
    limit: isLimitReachedModalOpen?.limit,
  };
}
